<template>
  <el-container class="main_container">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <router-view></router-view>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "index",
  data() {
    return {
      isMobilePhone: false
    };
  },

  created() {
    this.isMobile();
    this.isInSearch();
  },

  methods: {
    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );

      //isMobilePhone 代表设备信息 转换bool
      this.setMobileStatus(!!this.isMobilePhone)
    },

    //search不展示主页效果
    isInSearch() {
      const queryLength = Object.keys(this.$route.query).length
      this.changeIndexShow(!queryLength);
    },

    ...mapMutations(["setMobileStatus","changeIndexShow"])
  }
};
</script>

<style scoped>
.ismobilePhone {
  padding: 0px !important;
  background: #fff !important;
}
</style>
